export let BookingPolicyModalDataHooks = /*#__PURE__*/function (BookingPolicyModalDataHooks) {
  BookingPolicyModalDataHooks["Main"] = "booking-policy-modal";
  BookingPolicyModalDataHooks["PolicyDescriptionCard"] = "booking-policy-modal-policy-description-card";
  BookingPolicyModalDataHooks["PolicyDescriptionTitle"] = "booking-policy-modal-policy-description-title";
  BookingPolicyModalDataHooks["PolicyDescriptionContent"] = "booking-policy-modal-policy-description-content";
  BookingPolicyModalDataHooks["Spinner"] = "booking-policy-modal-spinner";
  BookingPolicyModalDataHooks["Footer"] = "booking-policy-modal-footer";
  BookingPolicyModalDataHooks["PrimaryButton"] = "booking-policy-modal-primary-button";
  return BookingPolicyModalDataHooks;
}({});
//# sourceMappingURL=datahooks.js.map